/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useNavTabsStyles = makeStyles(theme => ({
  root: {
    minHeight: '40px',

    '& .MuiTab-root': {
      minWidth: '160px',
      padding: '8px 16px',
      background: '#FFFFFF',
      border: '1px solid #EEEEEE',
      borderRadius: '6px',
      fontSize: '15px',
      lineHeight: '16px',
      textTransform: 'none',
      fontWeight: 400,
      minHeight: '40px',

      '&.Mui-selected': {
        fontWeight: 500,
        color: theme.palette.primary.main,
        borderColor: 'transparent',
        background: `${theme.palette.tertiary.main}20`,
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
      },

      '&.MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
        marginBottom: 0,
        marginRight: '10px',
      },

      marginLeft: '16px',
      '&:first-child': {
        marginLeft: '0px',
      },
    },
  },
}));

export const useVertNavTabsStyles = makeStyles(theme => ({
  root: {
    minHeight: '40px',

    '& .MuiTab-root': {
      minWidth: '160px',
      padding: '8px 16px',
      background: '#FFFFFF',
      border: '1px solid #EEEEEE',
      borderRadius: '6px',
      fontSize: '15px',
      lineHeight: '16px',
      textTransform: 'none',
      fontWeight: 400,
      minHeight: '40px',
      marginTop: '16px',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      textAlign: 'left',

      '&.Mui-selected': {
        fontWeight: 500,
        color: theme.palette.primary.main,
      },

      '&.MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
        marginBottom: 0,
        marginRight: '10px',
      },
      '&:first-child': {
        marginTop: '0px',
      },
      '& .MuiSvgIcon-root': {
        width: '20px',
        height: '20px',
      },
    },
  },
}));
